import type { RouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { GivingContentObjectDetailDataObject, PublicGivingContentObjectDataObject } from 'models/service';

type GivingsRequestParams = paths['/v3/givings/{id}']['get']['parameters']['path'];

const getGivingDetail = async <T>({ routeParams: { id } }: RouteParamsRequest<GivingsRequestParams>) =>
  apiClient.get<T, ApiClientResponse<T>>(routes.givings.detail(id));

export const getPublicGivingDetail = async (params: RouteParamsRequest<GivingsRequestParams>) =>
  getGivingDetail<PublicGivingContentObjectDataObject>(params);

export const getInternalGivingDetail = async (params: RouteParamsRequest<GivingsRequestParams>) =>
  getGivingDetail<GivingContentObjectDetailDataObject>(params);
